import { render, staticRenderFns } from "./GroupMainPage.vue?vue&type=template&id=406d1339&scoped=true&"
import script from "./GroupMainPage.vue?vue&type=script&lang=js&"
export * from "./GroupMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d1339",
  null
  
)

export default component.exports